import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { DefaultImgDirective } from './default-img.directive'

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    DefaultImgDirective,
  ],
  exports: [
    DefaultImgDirective,
  ]
})
export class DefaultImgModule {
}



// WEBPACK FOOTER //
// ./src/app/shared/default-img/default-img.module.ts